/**
 * Where the closed search bar sits on screen.
 * - `inline` — in the page flow. Desktop focus opens a dropdown; mobile focus
 *   moves the field to the bottom with suggestions above it.
 * - `dock` — pinned to the bottom of the screen, with suggestions above it when open.
 * - `auto` — `dock` on small screens, `inline` on desktop.
 * - `trigger` — `inline` on desktop. On small screens the closed field is hidden
 *   and the panel is opened from outside, for example a header icon.
 */
export type SearchPlacement = 'auto' | 'dock' | 'inline' | 'trigger'

/** `SearchPlacement` after `auto` is resolved for the current screen size. */
export type ResolvedSearchPlacement = Exclude<SearchPlacement, 'auto'>

/** A search suggestion shown before typing or returned by typeahead. */
export interface SearchTermSuggestion {
    /** Chip text shown to the user. */
    label: string
    /** Query submitted when the suggestion is selected. */
    query: string
}

export interface UseUniversalSearchOptions {
    /**
     * Text to show in the field. Does not submit a search or open typeahead.
     */
    searchQuery?: string
    /** Runs when the user dismisses the desktop dropdown or mobile panel. */
    onClose?: () => void
    /** Value sent as the analytics location for search events. */
    analyticsLocation?: string
}

/** Pause after typing before searching. */
export const TYPEAHEAD_DEBOUNCE_MS = 500
/** How many typeahead rows to show. */
export const TYPEAHEAD_MAX_ROWS = 5
